import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import CompleteProfile from "@/pages/CompleteProfile";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function Account() {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const changePw = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Password changed");
      setPw(""); setConfirm("");
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-5 max-w-2xl">
      <div>
        <h1 className="font-heading text-2xl font-extrabold">Account</h1>
        <p className="text-muted-foreground text-sm font-medium">Manage your company profile and password.</p>
      </div>

      <Tabs defaultValue="profile">
        <TabsList>
          <TabsTrigger value="profile" data-testid="account-tab-profile">Company Profile</TabsTrigger>
          <TabsTrigger value="password" data-testid="account-tab-password">Change Password</TabsTrigger>
        </TabsList>
        <TabsContent value="profile" className="mt-4">
          <CompleteProfile embedded />
        </TabsContent>
        <TabsContent value="password" className="mt-4">
          <form onSubmit={changePw} className="bg-card border rounded-2xl p-6 space-y-4 max-w-sm">
            <div><Label>New Password</Label><Input data-testid="acc-new-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required /></div>
            <div><Label>Confirm Password</Label><Input data-testid="acc-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
            <Button data-testid="acc-change-password" type="submit" disabled={busy} className="font-bold">{busy ? "Saving…" : "Update Password"}</Button>
          </form>
        </TabsContent>
      </Tabs>
    </div>
  );
}
